import { render, staticRenderFns } from "./DeleteVoucherComponent.vue?vue&type=template&id=49aa8798&"
import script from "./DeleteVoucherComponent.vue?vue&type=script&lang=js&"
export * from "./DeleteVoucherComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports